export const extractEhrInfoFromFhirBasic = (basicResource) => {
  const extension = basicResource.extension;

  const connectionId = extension.find((item) => {
    if (item?.url?.includes("connectionId")) {
      return true;
    }
  })?.valueString;

  const ehrName = extension.find((item) => {
    if (item?.url?.includes("ehrName")) {
      return true;
    }
  })?.valueString;

  return {
    ehrName,
    connectionId,
  };
};